import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class ResidentialCanteenRelationsApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/residential-canteen-partner-relations'
    }
}

export default new ResidentialCanteenRelationsApiClient()
